import { Header } from "views/admin/layouts/Header";
import { Sidebar } from "views/admin/layouts/Sidebar";

interface IFProps {
    children: any
}

export function AdminFrame(props:IFProps): JSX.Element{

    return (
        <div className="admin_layout">
            <Header/>
            <div className="admin_layout-contents-wrap">
                <div className="admin_layout-contents">
                    <Sidebar/>
                    <div className="admin_layout-main">
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    )

}